import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { OrderTypeEnum } from '@flipster/apis/types';
import { accountBunja } from '@flipster/r230522/original/account';
import type { PendingPosition } from '@flipster/r230522/original/order';

export type PendingTpslDisplay = 'hidden' | 'placeholder' | 'visible';

export function usePendingTpsl(order: PendingPosition) {
  const { v2AccountAtom } = useBunja(accountBunja);
  const account = useAtomValue(v2AccountAtom);

  const isLimitOrder = order.orderType === OrderTypeEnum['Limit'];
  const isReduceOnly = isLimitOrder ? order.isReduceOnly || order.action === 'Close' : order.isReduceOnly;

  const isMultiplePositions = account?.tradeMode === 'MultiplePositions';

  const tpslDisplay: PendingTpslDisplay = (() => {
    // limit order
    if (isLimitOrder) {
      if (isReduceOnly) return 'placeholder';
      return 'visible';
    }

    // time trigger order
    if (order.triggerTimestamp) {
      if (isMultiplePositions) return 'visible';
      return 'placeholder';
    }

    // trigger order
    if (isReduceOnly) return 'placeholder';
    // BBO Trigger Limit (`StopLimit` + `priceMatchStrategy`): order-form disables BBO once
    // TP/SL is set, so a BBO row can never carry TP/SL — render as not-configurable.
    if (order.priceMatchStrategy) return 'placeholder';
    return 'visible';
  })();

  return { tpslDisplay };
}
